// @flow

import React, { Component } from 'react';
import glamorous from 'glamorous';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import { Redirect } from 'react-router-dom';
import ChallengeTimeStatusInfo from '../../components/challenge/ChallengeTimeStatusInfo';
import BackToReferrerArrow from '../../components/commons/BackToReferrerArrow';
import Loader from '../../components/commons/Loader';
import Container from '../../components/layout/Container';
import Responsive from '../../components/responsive/Responsive';
import UserOnly from '../../components/util/UserOnly';
import { IN_PROGRESS } from '../../constants/challengeStatusTypes';
import Page from '../../containers/parts/Page';
import Header from './Header';
import RapidFireLiveChallenge from './RapidFireLiveChallenge';
import RapidFireOpenChallenge from './RapidFireOpenChallenge';
import * as challengeActions from '../../actions/challengeActions';

type Props = {
  challengeId: string,
  challengeName: ?string,
  entryId?: number | string,
  fetchChallenge: () => void,
  hasInitialised: boolean,
  isLoading: boolean,
  resetChallenge: () => void,
  startTime?: number | string,
  statusLabel?: string,
  statusId: number,
};

const Title = glamorous.div(({ theme }) => ({
  fontSize: theme.fontSize.large,
  fontWeight: theme.fontWeight.bold,
  textTransform: 'uppercase',
  padding: theme.spacing.xsmall,
  [theme.mediaQuery.desktopAndUp]: {
    padding: theme.spacing.small,
  },
}));

const StyledBackToReferrerArrow = glamorous(BackToReferrerArrow)(({ theme }) => ({
  '& > a': {
    color: theme.color.white,
  },
  alignSelf: 'flex-start',
  fontSize: '1.5em',
  padding: '0.5em',
}));

class RapidFireChallenge extends Component<Props> {
  props: Props;

  static defaultProps = {
    entryId: undefined,
    startTime: undefined,
    statusLabel: undefined,
  };

  componentDidMount() {
    const { challengeId, fetchChallenge } = this.props;

    fetchChallenge(challengeId);
  }

  componentWillUnmount() {
    this.props.resetChallenge();
  }

  render() {
    const {
      challengeName,
      entryId,
      hasInitialised,
      isLoading,
      startTime,
      statusLabel,
      statusId,
    } = this.props;

    const isOpen = statusId < IN_PROGRESS;

    return (
      <UserOnly>
        <Page title="RapidFire">
          <Container size="medium">
            {isLoading || !hasInitialised ? (
              <Loader pad />
            ) : (
              <React.Fragment>
                {!entryId && <Redirect to="/" />}
                <Header>
                  <Responsive mobile>
                    <StyledBackToReferrerArrow />
                  </Responsive>
                  <Title>{challengeName}</Title>
                  <ChallengeTimeStatusInfo
                    startTime={startTime}
                    statusId={statusId}
                    statusLabel={statusLabel}
                  />
                </Header>
                {isOpen ? <RapidFireOpenChallenge /> : <RapidFireLiveChallenge />}
              </React.Fragment>
            )}
          </Container>
        </Page>
      </UserOnly>
    );
  }
}

RapidFireChallenge.defaultProps = {
  entryId: undefined,
};

function mapStateToProps(state, { match }) {
  const { challengeId } = match.params;
  return {
    challengeId,
    challengeName: state.challenge.name,
    entryId: get('entry.myEntry.id', state),
    hasInitialised: state.challenge.hasInitialised && state.challenge.id === challengeId,
    isLoading: state.challenge.isLoading,
    startLabel: state.challenge.statusLabel,
    startTime: state.challenge.startTime,
    statusId: state.challenge.statusId,
  };
}

const actions = {
  fetchChallenge: challengeActions.fetchChallenge,
  resetChallenge: challengeActions.resetChallenge,
};

export default connect(
  mapStateToProps,
  actions,
)(RapidFireChallenge);
